/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function PreferenceCenter_enablePrivacyPolicy(preferenceCenter) {
    const privacyPolicyContainer = preferenceCenter.querySelector('[data-component="PrivacyPolicyContainer"]');
    if (privacyPolicyContainer instanceof HTMLElement) {
        privacyPolicyContainer.style.display = "";
    }
}